import { render, staticRenderFns } from "./student-login-form.vue?vue&type=template&id=aa97f7f6&lang=pug&"
import script from "./student-login-form.vue?vue&type=script&lang=js&"
export * from "./student-login-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports